
import React, { useEffect, useState } from 'react'
import { useSocket } from '../context/socketProvider'
import ReactPlayer from 'react-player';
import peer from '../service/peer';

export default function Room() {
    const socket =useSocket();
  const [remoteSocketId,setRemoteSocketId] = useState();
  const [myStream,setMyStream] = useState();
  const [remoteStream,setRemoteStream] = useState()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleUserJoined = ({email,id})=>{ 
        console.log(`${email} of id ${id} joined the room`)
        setRemoteSocketId(id);
  }

  const handleUserVideo = async()=>{ 
    try {
        
    const stream = await navigator.mediaDevices.getUserMedia({ 
        audio:true,
        video:true
    })
    await peer.addTracks(stream)
    
    setMyStream(stream);
    
    const offer = await peer.getOffer();
    console.log("offer!!!",offer);

    socket.emit("send-call",{to:remoteSocketId,offer});
    } catch (error) {
        throw("handleUserVideo:",error)
    }
  }


// eslint-disable-next-line react-hooks/exhaustive-deps
const handleIncomingCall = async({from,offer})=>{
  const stream = await navigator.mediaDevices.getUserMedia({ 
    audio:true,
    video:true
})
await peer.addTracks(stream)
setMyStream(stream);
setRemoteSocketId(from)
const ans = await peer.getAnswer(offer);
socket.emit("call-accepted",{to:from,ans});
}


// eslint-disable-next-line react-hooks/exhaustive-deps
const handleFinalCall=async(ans)=>{
  await peer.setLocalDescription(ans);
}

useEffect(() => {
  peer.peer.addEventListener("track", async (ev) => {
    const remoteStream = ev.streams;
    console.log("GOT TRACKS!!");
     setRemoteStream(remoteStream[0]);
   
    console.log("yeh remote stream",remoteStream);
   
  });
}, []);


    useEffect(()=>{ 
        socket.on("joined-room",handleUserJoined)
        socket.on("incoming-call",handleIncomingCall);
        socket.on("ans-accepted",handleFinalCall);
    return ()=>{ 
        socket.off("joined-room",handleUserJoined);
        socket.off("incoming-call",handleIncomingCall);
        socket.off("ans-accepted",handleFinalCall);
    }
    },[socket,handleUserJoined,handleIncomingCall,handleFinalCall])




  return (
    <div>
    <h3>{socket.id}</h3>
   {remoteSocketId?<h3>A new user joined</h3>:<h3>No one joined</h3>}
   {remoteSocketId&&<button onClick={handleUserVideo}>Connect</button>}
   <div style={{display:'flex',justifyContent:'center',alignItems:"center"}}>
   {myStream &&<>
    <h1>My Stream</h1>
    <ReactPlayer  muted playing height="150px"  width="250px" url={myStream}/>
   </>}
   </div>
   {remoteStream&&<>
        <div style={{display:'flex',justifyContent:'center',marginTop:"16px", alignContent:'center'}}>
            <h1>Remote Stream</h1>
         <ReactPlayer  muted playing height="150px"  width="250px" url={remoteStream}/>
         </div>
        </>}
    </div>
  )
}
